import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { LucideTriangleAlert } from '@lucide/angular';
import {
  contractRelationLabels,
  designationScopeLabels,
  NotificationDesignation,
  roleLabel,
} from '../notification-setting.model';

/**
 * Les destinataires d'une ligne de réglage : profils et portée, relations au contrat. Une ligne qui
 * ne désigne personne le dit, pour qu'un silence ne soit jamais invisible
 * (RG-notification-reglage-des-destinataires).
 */
@Component({
  selector: 'app-designation-chips',
  imports: [LucideTriangleAlert],
  templateUrl: './designation-chips.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./designation-chips.scss'],
})
export class DesignationChips {
  readonly designations = input.required<NotificationDesignation[]>();
  readonly emptyLabel = input("Personne n'est notifié");

  protected readonly roleLabel = roleLabel;
  protected readonly scopeLabels = designationScopeLabels;
  protected readonly relationLabels = contractRelationLabels;
}
